/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/slicedToArray";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
var ua = window.navigator.userAgent;

var packageJson = require('../../package.json');

var env = {
  isWeixin: /micromessenger/i.test(ua),
  isAndroid: /android/i.test(ua),
  isAlipayClient: /AlipayClient/i.test(ua),
  isAliMP: ua.indexOf('AlipayClient') > -1 && ua.indexOf('MiniProgram') > -1,
  isAliMPMonitor: ua.indexOf('AlipayClient') > -1 && ua.indexOf('AlipayIDE') > -1,
  isIOS: /iPad|iPhone|iPod/.test(ua),
  isThirdParty: /wifiwx|DingTalk/i.test(ua) || !!window.HBJsBridge,
  isEasyBikeApp: false,
  // app版本号 oldversion为3.5.2(含)之前的版本
  appVersion: packageJson.version,
  iosVersion: null,
  isWeibo: /weibo/i.test(ua),
  isQQ: /QQ\//.test(ua)
};

if (env.isIOS) {
  var matches = ua.toLocaleLowerCase().match(/cpu iphone os (.*?) like mac os/);
  env.iosVersion = matches && matches[1].replace(/_/g, '.');
}

function extractApp() {
  // eslint-disable-next-line
  var matches = ua.match(/\b\s*app=easybike(?:;\s*version=([\d\.]+))*/i);

  if (matches) {
    env.isEasyBikeApp = true;

    var _matches = _slicedToArray(matches, 2);

    env.appVersion = _matches[1];

    if (!env.appVersion) {
      env.appVersion = '0.0.0';
    }
  }
}

extractApp();
env.platform = {
  os: 'other',
  app: 'browser'
};

if (env.isAndroid) {
  env.platform.os = 'Android';
} else if (env.isIOS) {
  env.platform.os = 'IOS';
}

if (env.isWeixin) {
  env.platform.app = 'wechat';
} else if (env.isEasyBikeApp) {
  env.platform.app = 'hellobike_app';
} else if (env.isAlipayClient) {
  env.platform.app = 'alipay';
} else if (env.isThirdParty) {
  env.platform.app = 'third_party_app';
} else if (env.isQQ) {
  env.platform.app = 'qq';
} else if (env.isWeibo) {
  env.platform.app = 'weibo';
}

env.platformCode = {
  browser: 1,
  wechat: 2,
  alipay: 3,
  hellobike_app: 4,
  third_party_app: 5,
  qq: 6,
  weibo: 7
}[env.platform.app];
env.platform.bizVersion = packageJson.version;
env.codeEnv = process.env.VUE_APP_ENV;

if (env.codeEnv === 'test') {
  env.codeEnv = 'dev';
}

env.cdnEnv = env.codeEnv === 'pro' ? '' : "".concat(env.codeEnv, "/");
export default env;